import React from 'react';
import { Link } from 'react-router-dom';

const navigation = [
  { name: 'Home', href: '/' },
  { name: 'What Is Coherence OS', href: '/what-is-coherence-os' },
  { name: 'The Category', href: '/the-category' },
  { name: 'Coherence Metrics', href: '/coherence-metrics' },
  { name: 'For Investors', href: '/for-investors' },
  { name: 'For Builders', href: '/for-builders' },
  { name: 'Articles', href: '/articles' },
];

export const Footer = () => {
  return (
    <footer className="bg-background">
      {/* Thin divider rule */}
      <div className="editorial-container-wide">
        <hr className="border-t border-border" />
      </div>
      
      <div className="editorial-container-wide py-12 md:py-16">
        {/* Navigation */}
        <nav className="mb-10">
          <ul className="flex flex-wrap gap-x-6 gap-y-2">
            {navigation.map((item) => (
              <li key={item.name}>
                <Link to={item.href} className="footer-link">
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        {/* Brand and copyright */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <Link 
              to="/" 
              className="font-serif text-xl font-medium tracking-tight text-foreground hover:text-foreground/80 transition-colors"
            >
              Coherence OS
            </Link>
            <p className="mt-2 text-sm text-muted-foreground max-w-md">
              An operating system for civilization-scale alignment.
            </p>
          </div>
          
          <div className="text-sm text-muted-foreground text-right">
            <p>Filed and pending patents.</p>
            <p className="mt-1">© {new Date().getFullYear()} Coherence OS</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
